export default "__VITE_ASSET__Dcq0Ku6$__"